import {valueof} from '../../types';

enum IV_PHOTO_SOURCE {
  appCamera = 'APP_CAMERA',
  nativeCamera = 'NATIVE_CAMERA',
  external = 'EXTERNAL',
}

enum IV_DOCUMENT_IMAGE_TYPES {
  front = 'front',
  back = 'back',
  selfie = 'selfie',
}

const IV_PROCESS_TYPE = {
  beforeArrival: 'BEFORE_ARRIVAL',
  onProperty: 'ON_PROPERTY',
} as const;
type IV_PROCESS_TYPE = valueof<typeof IV_PROCESS_TYPE>;

const OCR_CHECKING_STATUSES = {
  error: 'ERR',
  complete: 'COM',
  processing: 'PRO',
  new: 'NEW',
};

enum IMAGE_SERVICE_ORIGIN {
  ocr = 'ocr',
  biomatch = 'biomatch',
}

enum IVStatus {
  complete = 'COM',
  error = 'ERR',
  new = 'NEW',
  process = 'PRO',
}

enum IDENTITY_VERIFICATION_TYPES {
  ocr = 'OCR',
  biomatch = 'BIOMATCH',
  document = 'DOCUMENT',
}

export {
  IV_PHOTO_SOURCE,
  IV_DOCUMENT_IMAGE_TYPES,
  IV_PROCESS_TYPE,
  OCR_CHECKING_STATUSES,
  IMAGE_SERVICE_ORIGIN,
  IDENTITY_VERIFICATION_TYPES,
  IVStatus,
};
